import React, { useState } from "react";
import { supabase } from "../../utils/supabase";
import { User } from "@supabase/supabase-js";

type LoginPageProps = {
  setAuthentication: (data: User) => void;
};

export const LoginPage: React.FC<LoginPageProps> = ({ setAuthentication }) => {
  const [loginEmail, setLoginEmail] = useState<string>("");
  const [loginPassword, setLoginPassword] = useState<string>("");
  const [loginError, setLoginError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleLogin = async () => {
    setLoginError("");
    setIsLoading(true);

    try {
      const { data } = await supabase.auth.signInWithPassword({
        email: loginEmail,
        password: loginPassword,
      });

      if (data.user) {
        setAuthentication(data.user);
      } else {
        setLoginError("Credenciales incorrectas");
      }
    } catch (error) {
      setLoginError("Error al iniciar sesión. Intenta nuevamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-full w-auto py-8">
        <div className="bg-white rounded-2xl shadow-xl p-8 flex flex-col md:flex-row gap-8 h-[70vh] items-center justify-center">
          <div className="w-full md:w-1/2">
            <div className="w-full h-auto flex items-center justify-center">
              <img
                src="/Aniversario75.webp"
                alt="Logo UAT"
                className="w-44 mb-6"
              />
            </div>
            <h3 className="text-2xl font-semibold mb-2 text-center">
              Feria de Emprendedores UAT
            </h3>
            <p className="text-blue-500 text-center text-sm">
              Impulsando el talento y la innovación de nuestros estudiantes.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-4 mt-4">
              Acceso exclusivo
            </h3>
            <p className="text-gray-600 text-sm mb-4">
              Solo personal autorizado puede ingresar al panel de administración
              de la Feria de Emprendedores.
            </p>
            <p className="text-gray-500 text-xs">
              Si tienes problemas para acceder, contacta con:
            </p>
            <p className="text-blue-600 font-medium text-sm">soporte@uat.mx</p>
          </div>
          <div>
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">
                Panel de Administración
              </h2>
              <p className="text-gray-600">Feria de Emprendedores UAT</p>
            </div>

            <div className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Correo electrónico
                </label>
                <input
                  id="email"
                  type="email"
                  value={loginEmail}
                  onChange={(e) => setLoginEmail(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                  placeholder="admin@ejemplo.com"
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Contraseña
                </label>
                <input
                  id="password"
                  type="password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                  placeholder="••••••••"
                />
              </div>

              {loginError && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                  {loginError}
                </div>
              )}

              <button
                onClick={handleLogin}
                disabled={isLoading}
                className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <span className="flex items-center justify-center gap-2">
                    <span className="animate-spin">⏳</span>
                    Iniciando sesión...
                  </span>
                ) : (
                  "Iniciar Sesión"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
